import Navigation from "./Navigation";

type HeaderProps = {
  yourLogo?: string;
  configData?: any[];
  base_path?: string;
  cartUrl?: string;
};

const Header = ({ yourLogo, configData, base_path, cartUrl }: HeaderProps) => {
  return (
    <Navigation 
      configData={configData}
      yourLogo={yourLogo}
      base_path={base_path}
      cartUrl={cartUrl}
      mode="header"
    />
  );
};

export default Header;
